import React from "react";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Image from "next/image";
import TelMail from "@/public/static/images/contact-mail.png";
import Link from "next/link";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Fade from "@mui/material/Fade";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
function FloatingButton() {
  return (
    <div className="position-relative">
      <Box className="floating-btn">
        <Link href="/th/contactus">
          <Fab
            size="medium"
            color="primary"
            aria-label="add"
            className="floating"
            sx={{ position: "fixed", bottom: 25, right: 16 }}
          >
            <Tooltip title="Go to Contact Us" placement="left">
              <Image loading="lazy" src={TelMail} alt="Contact" width={300} />
            </Tooltip>
          </Fab>
        </Link>
      </Box>
    </div>
  );
}
export default FloatingButton;
